
const main = () => {
  const hamburger = document.querySelector('.l-header-head-block__hamburger');
  const headerNav = document.querySelector('.l-header-nav');
  const body = document.body;
  const navLinks = headerNav.querySelectorAll('a');

  hamburger.addEventListener('click', (e) => {
    e.preventDefault();
    toggleMenu();
  });

  const toggleMenu = () => {
    if (hamburger.hasAttribute('data-active')) {
      closeMenu();
    } else {
      openMenu();
    }
  };
  const openMenu = () => {
    hamburger.setAttribute('data-active', '');
    headerNav.setAttribute('data-active', '');
    body.classList.add('is-scroll-lock');
  };
  const closeMenu = () => {
    hamburger.removeAttribute('data-active');
    headerNav.removeAttribute('data-active');
    body.classList.remove('is-scroll-lock');
  };

  navLinks.forEach((link) => {
    link.addEventListener('click', () => {
      closeMenu();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMenu();
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 768) {
      closeMenu();
    }
  });
};

export default main;
